// extracted by mini-css-extract-plugin
export default {"img-container":"NpsImg_img-container__bZiAE","img":"NpsImg_img__KFrxQ"};